export default __webpack_public_path__ + "static/karolina-2a3e583d784d4535403ba54375957d8e.png";